import script from "./OperatorApplicationLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationLayout.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationLayout.vue?vue&type=style&index=0&id=ec50ed22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec50ed22"]])

export default __exports__